import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class FinalSale extends HTMLElement {
    connectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.addEventListener(StandardEvents.productSelect, this.updateFinalSale);
    }

    disconnectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.removeEventListener(StandardEvents.productSelect, this.updateFinalSale);
    }

    /**
     * Updates the final sale message and line item property.
     * @param {ProductSelectEvent} event - The variant update event.
     */
    updateFinalSale = (event) => {

        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

        event.promise
            .then(({ detail }) => {
                if (!detail?.html) return;

                const { html, newProduct } = detail;

                if (newProduct) {
                    this.dataset.productId = newProduct.id;
                } else if (detail.productId && detail.productId !== this.dataset.productId) {
                    return;
                }

                const newFinalSale = html.querySelector('final-sale [ref="finalSaleContainer"]');
                const currentFinalSale = this.querySelector('[ref="finalSaleContainer"]');
                if (!newFinalSale || !currentFinalSale) return;

                if (currentFinalSale.innerHTML !== newFinalSale.innerHTML) {
                    currentFinalSale.replaceWith(newFinalSale);
                }
            })
            .catch((error) => {
                if (error?.name !== 'AbortError') console.warn('[final-sale] Event promise rejected:', error);
            });
    };
}

if (!customElements.get('final-sale')) {
    customElements.define('final-sale', FinalSale);
}
